// extracted by mini-css-extract-plugin
export default {"container":"admins-overview_page_container__QgCFa","headerContainer":"admins-overview_page_headerContainer__Bb5AK"};